import axios from '../axios'
// 当前用户的菜单
export const postMenu = (data) => {
  return axios({
    url: '/con/manage/menu/get_menu_by_uid',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/menu.js